import { Card, Carousel, Image, Modal } from "antd";
import activitylog from "assets/activitylog.svg";
import dayjs from "dayjs";
import { useMemo, useState } from "react";

interface VehicleImage {
  cameraId: string;
  image: string;
}

interface CarouselImage {
  src: string;
}

interface ActivityLog {
  vImage?: VehicleImage[]; // optional
}

type ArrowProps = {
  currentSlides: number;
  slideCount: number;
  onClick?: () => void;
};

export const ActivityLogView = ({ activitylogdata, isLoading }: any) => {
  const [expandedIndexes] = useState<{ [key: number]: boolean }>({});
  const [open, setOpen] = useState(false);
  // const [activeIndex, setActiveIndex] = useState(0);
  // const [modalImages, setModalImages] = useState<any[]>([]);
  

 
  // New Code

  const [currentSlide, setCurrentSlide] = useState<number>(0);
const findImageIndex = (imageUrl: string): number => {
  return allImages.findIndex(img => img.src === imageUrl);
};
  // 🔹 Flatten all images into ONE array
const allImages = useMemo<CarouselImage[]>(() => {
  if (!Array.isArray(activitylogdata)) return [];

  return activitylogdata.flatMap((txn: ActivityLog) =>
    Array.isArray(txn.vImage)
      ? txn.vImage.map(img => ({ src: img.image }))
      : []
  );
}, [activitylogdata]);

const PrevArrow = ({
  currentSlides,
  onClick,
}: ArrowProps) => {
  if (currentSlides === 0) return null;

  return (
    <div
      onClick={onClick}
      style={{
        position: 'absolute',
        left: 10,
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 10,
        cursor: 'pointer',
        fontSize: 18,
        fontWeight: 500,
        background: 'rgba(255,255,255,0.8)',
        padding: '6px 12px',
        borderRadius: 6,
      }}
    >
      {'<'} 
    </div>
  );
};

const NextArrow = ({
  currentSlides,
  slideCount,
  onClick,
}: ArrowProps) => {

  if (currentSlides === slideCount - 1) return null;

  return (
    <div
      onClick={onClick}
      style={{
        position: 'absolute',
        right: 10,
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 10,
        cursor: 'pointer',
        fontSize: 18,
        fontWeight: 500,
        background: 'rgba(255,255,255,0.8)',
        padding: '6px 12px',
        borderRadius: 6,
      }}
    >
       {'>'}
    </div>
  );
};

 // 🔹 Image click handler
 
const onImageClick = (index: number) => {
  setCurrentSlide(index); // 🔥 set clicked image index
  setOpen(true);
};
 
  const openImageModal = (images: string) => {
    // setModalImages(images);
    // setActiveIndex(index);
    setOpen(true);
     onImageClick(findImageIndex(images));
   
  };

  return (
    <>
      <Card title="Activity Log" style={{ borderRadius: 12 }} loading={isLoading}>
        <div className="relative flex flex-col items-start">
          {activitylogdata?.map((item: any, index: number) => {
            const isExpanded = expandedIndexes[index] || false;
            const images = isExpanded ? item.vImage : item.vImage?.slice(0, 6);

            return (
              <div key={index} className="flex items-start relative w-full mb-6">
                {index !== activitylogdata.length - 1 && (
                  <div className="absolute left-5 top-10 w-[2px] bg-gray-300 h-full" />
                )}

                {/* Timeline Icon */}
                <div className="flex flex-col items-center mr-4">
                  <div
                    className={`w-10 h-10 flex items-center justify-center rounded-full border-2 shadow-sm ${item.actionType
                      ? "bg-green-500 border-green-500 text-white"
                      : "bg-white border-gray-400 text-gray-500"
                      }`}
                  >
                    <img src={activitylog} alt="log-icon" className="w-5 h-5" />
                  </div>
                </div>

                {/* Log Content */}
                <div className="flex flex-col p-4 rounded-lg shadow-md flex-1 bg-white">
                  <h3 className="font-semibold text-gray-800 mb-1">
                    {item.actionType}
                  </h3>

                  {item.transactionRemark && (
                    <div className="mb-3 px-3 py-2 border border-gray-200 rounded-lg bg-gray-100 text-sm text-gray-700">
                      {item.transactionRemark}
                    </div>
                  )}

                  <span className="text-xs text-gray-500 mb-2">
                    {dayjs(item.createdOn).format("DD-MMM-YYYY hh:mm A")}
                  </span>

                  {item.stationName && (
                    <span className="text-xs text-gray-500 mb-2">
                      {item.stationName}
                    </span>
                  )}

                  {item.actionType === "Exit" && item.isAccountApproved && (
                    <span className="text-xs text-gray-500 mb-2">
                      Exit Gate Status : {item.isAccountApproved}
                    </span>
                  )}

                  {item.actionType === "Weight" && item.weight && (
                    <span className="text-xs text-gray-500 mb-2">
                      {item.weight} kg
                    </span>
                  )}

                  {/* Images */}
                  {item?.vImage?.length > 0 && (
                    <div className="grid grid-cols-4 sm:grid-cols-8 gap-3 mt-2">
                      {images.map((img: any, idx: number) => (
                        <div
                          key={idx}
                          onClick={() => openImageModal(img.image)}
                          className="cursor-pointer overflow-hidden rounded-lg border border-gray-200 shadow-sm"
                        >
                          <Image
                            src={img.image}
                            preview={false}
                            width={40}
                            height={40}
                            style={{
                              objectFit: "cover",
                              width: "100%",
                              height: "100%",
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </Card>

         <Modal
  open={open}
  footer={null}
  width={600}
  destroyOnClose
  centered
  onCancel={() => {
    setOpen(false);
    setCurrentSlide(0);
  }}
>
  <div style={{ position: 'relative' }}>
    <Carousel
      key={currentSlide}                // 🔥 FORCE re-render
      arrows
      infinite={false}
      initialSlide={currentSlide}       // 🔥 START FROM CLICKED IMAGE
      afterChange={(index) => setCurrentSlide(index)}
      prevArrow={
        <PrevArrow
          currentSlides={currentSlide}
          slideCount={allImages.length}
        />
      }
      nextArrow={
        <NextArrow
          currentSlides={currentSlide}
          slideCount={allImages.length}
        />
      }
    >
      {allImages.map((img, index) => (
        <div
          key={index}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: 350,
          }}
          className="!flex justify-center"
        >
          <Image
            src={img.src}
            preview={false}
            style={{
              // maxHeight: 300,
              // maxWidth: '90%',
              // objectFit: 'contain',
            }}
          />
        </div>
      ))}
    </Carousel>
  </div>
</Modal>
      {/* IMAGE MODAL */}
      {/* <Modal
        open={open}
        footer={null}
        onCancel={() => setOpen(false)}
        width={600}
        centered
      >
        <Carousel 
        arrows
          infinite={false}
          initialSlide={activeIndex}
         
          prevArrow={<LeftOutlined />}
          nextArrow={<RightOutlined />}
          
        >
          {modalImages.map((img: any, idx: number) => (
            <div key={idx} className="!flex justify-center">
              <Image
                src={img.image}
                preview={false}
                style={{
                  // maxHeight: "70vh",
                  // objectFit: "contain",
                  // margin:'auto'
                }}
              />
            </div>
          ))}
        </Carousel>
      </Modal> */}
    </>
  );
};
